import React from 'react';
import PropTypes from 'prop-types';

import DataProvider from '../../HO/State/DataProvider';
import { Provider } from './MenuBottomContext';

const MenuBottomProvider = ({ children, form }) => (
  <DataProvider route="menuBottom" Provider={Provider} form={form}>
    {children}
  </DataProvider>
);

MenuBottomProvider.propTypes = {
  children: PropTypes.node.isRequired,
  form: PropTypes.instanceOf(Object),
};

MenuBottomProvider.defaultProps = {
  form: null,
};

export default MenuBottomProvider;
